module.exports = "/_next/static/images/591d24374a1616273de617f590746a5d-cards-right-large.jpg.webp";